<template>
  <div>
    <div class="text-center my-4 p-4">
      <h1 class="uppercase text-xl font-extrabold p-2">Thank you</h1>
      <div>Thank you for completing your Fine & Country Annual Review.</div>
      <div>Before clicking final 'Submit' button, please confirm the list below are all green and resolve any unticked sections.</div>
      <div>Once submitted the review is no longer editable.</div>
      <div class="border-b p-4 flex justify-between cursor-pointer" v-for="(value,index) in completeStatus" :key="index" @click="goPage(value.page)">
        <div>{{index+1}}. {{value.name}}</div>
        <div>
          <div class="flex items-center justify-center rounded-full w-10 h-10 bg-green transition scale-out" v-if="value.value === 2">
            <span class="fas fa-check text-2xl text-white"></span>
          </div>
          <div class="flex items-center justify-center rounded-full w-10 h-10 bg-yellow transition scale-out" v-else-if="!value.value">
            <span class="fas fa-exclamation-triangle text-lg"></span>
          </div>
          <div class="flex items-center justify-center rounded-full w-10 h-10 bg-grey transition scale-out" v-else>
            <span class="fas fa-minus text-lg"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewQuestionComponent from '@/components/AnnualReview/ReviewQuestionComponent'
export default {
  components: { ReviewQuestionComponent },
  props: ['value', 'review', 'page', 'sectionStart'],
  data () {
    return {
      form: this.value,
      completeStatus: [
        { name: 'Performance Review', value: 0, page: 0 },
        { name: 'Marketing Strategy', value: 0, page: 0 },
        { name: 'Fine & Country licensees "annual performance indicators"', value: 0, page: 0 },
        { name: 'Social Media Review', value: 0, page: 0 },
        { name: 'Foundation Pledge', value: 0, page: 0 },
        { name: 'Microsite Review', value: 0, page: 0 },
        { name: 'Administration Review', value: 0, page: 0 },
        { name: 'Email Review', value: 0, page: 13 },
        { name: 'Territory Review', value: 0, page: 14 },
        { name: 'Agree actions and objectives', value: 0, page: 15 }
      ],
      incompletePages: []
    }
  },
  mounted () {
    let flattenQuestions = this.flattenObject(this.form.questions, 3)
    for (let i = 1; i <= this.completeStatus.length; i++) {
      let sectionNumber = 0
      let completedNumber = 0
      for (let index in flattenQuestions) {
        if (parseInt(flattenQuestions[index].section_id) === i && flattenQuestions[index].mandatory) {
          sectionNumber++
          if (flattenQuestions[index].result !== null) {
            completedNumber++
          } else {
            if (!this.incompletePages.includes(flattenQuestions[index].page_id)) {
              this.incompletePages.push(flattenQuestions[index].page_id)
              this.completeStatus[i - 1].page = (this.completeStatus[i - 1].page === 0 || this.completeStatus[i - 1].page > flattenQuestions[index].page_id) ? flattenQuestions[index].page_id : this.completeStatus[i - 1].page
            }
          }
        }
      }
      this.completeStatus[i - 1].value = (sectionNumber !== completedNumber) ? 0 : sectionNumber === 0 ? 1 : 2
      // check email status page
      if (i === 8) {
        for (var emailIndex in this.review.emailStatus) {
          if (this.review.emailStatus[emailIndex].is_active === null && this.review.emailStatus[emailIndex].is_ms_exchange === null &&
            this.review.emailStatus[emailIndex].is_pop3 === null && this.review.emailStatus[emailIndex].receive_newsletter === null &&
            this.review.emailStatus[emailIndex].remove === null
          ) {
            this.completeStatus[i - 1].value = 0
            break
          }
          this.completeStatus[i - 1].value = 2
        }
      }
    }

    if (this.incompletePages.length > 0) {
      this.$emit('page-incomplete', this.incompletePages)
    }
  },
  methods: {
    flattenObject (ob, maxLevel = null) {
      var toReturn = {}
      if (maxLevel) {
        maxLevel--
      }
      for (var i in ob) {
        if (!ob.hasOwnProperty(i)) {
          continue
        }

        if ((typeof ob[i]) === 'object' && ob[i] !== null && maxLevel > 0) {
          var flatObject = this.flattenObject(ob[i], maxLevel)
          for (var x in flatObject) {
            if (!flatObject.hasOwnProperty(x)) {
              continue
            }

            toReturn[i + '.' + x] = flatObject[x]
          }
        } else {
          toReturn[i] = ob[i]
        }
      }
      return toReturn
    },
    goPage (page) {
      console.log(page)
      this.$emit('changePage', page)
    }
  }
}
</script>
